import React from 'react';
import { toast } from 'react-toastify';
import { NotError } from 'components';
import { call, put, takeLatest } from 'redux-saga/effects';
import { formService } from './form.service';
import {
    CHANGE_FORM_STATUS,
    CLIENT_FORM_REVIEW,
    CREATE_FORM,
    DELETE_FORM,
    EDIT_FORM,
    GET_CLIENT_FILED_FORM,
    GET_CLIENT_FILED_FORM_SUCCESS,
    GET_CLIENT_INVITE_FORM,
    GET_CLIENT_INVITE_FORM_SUCCESS,
    GET_FORM_BY_ID,
    GET_FORM_BY_ID_SUCCESS,
    GET_FORM_SETTINGS,
    GET_FORM_SETTINGS_SUCCESS,
    GET_FORMS,
    GET_FORMS_DEFAULT,
    GET_FORMS_DEFAULT_SUCCESS,
    GET_FORMS_SUCCESS,
    REQUEST_INVITE_FORM,
    RESEND_INVITE_FORM,
    SAVE_INVITE_FORM,
} from './form.type';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';
import { clientStatusEnums as clientStatusesEnum } from '../../utils';

function* getForms(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(formService.getFormsService, action.payload.params);
        yield put({
            type: GET_FORMS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

// function* getBasicForms(action) {
//     if (action?.payload?.load !== 'noLoad') {
//         yield put(httpRequestsOnLoadActions.appendLoading(action.type));
//     }
//     yield put(httpRequestsOnErrorsActions.removeError(action.type));
//     try {
//         const res = yield call(formService.getBasicFormsService, action?.payload?.model, action?.payload?.params);
//         yield put({
//             type: GET_BASIC_FORMS_SUCCESS,
//             payload: res.data,
//         });
//         yield put(httpRequestsOnLoadActions.removeLoading(action.type));
//     } catch (err) {
//         yield put(httpRequestsOnLoadActions.removeLoading(action.type));
//         if (err?.data?.message === 'Internal server error') {
//             yield put(
//                 httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message),
//             );
//         }
//     }
// }

function* getFormDefault(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(formService.getFormDefaultService, action?.payload?.formId, action?.payload?.params);
        yield put({
            type: GET_FORMS_DEFAULT_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getFormById(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const resourceId = action?.payload?.resourceId;
        const res = yield call(
            formService.getFormByIdService,
            action?.payload?.id,
            resourceId ? { resourceId } : undefined,
        );
        yield put({
            type: GET_FORM_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_FORM_BY_ID_SUCCESS,
            payload: {},
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getFormSettings(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(formService.getFormSettingsService);
        yield put({
            type: GET_FORM_SETTINGS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* createForm(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(formService.createFormService, action?.payload?.params);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type, res?.data));
        // window.location.replace(`/template/${res?.data?.data?.id}`);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editForm(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(formService.editFormService, action?.payload?.id, action?.payload?.params);
        const res = yield call(formService.getFormByIdService, action?.payload?.id);
        yield put({
            type: GET_FORM_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteForms(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(formService.deleteFormsService, action?.payload?.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getClientInviteForm(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(formService.getClientInviteFormService, action?.payload?.token);
        yield put({
            type: GET_CLIENT_INVITE_FORM_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.response?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* saveInviteForm(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(formService.saveInviteFormService, action?.payload?.params, action?.payload?.registerToken);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* resendInviteForm(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(formService.resendInviteFormService, action?.payload?.params);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* requestInviteForm(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(formService.requestInviteFormService, action?.payload?.inviteToken);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getClientFiledForm(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(formService.getClientFiledFormService, action?.payload?.clientId);

        const params = {
            ...res.data,
        };

        params.sections[0]?.attributes.unshift({
            label: 'Client Status',
            name: 'clientStatus',
            type: 'SELECT',
            defaultDateType: 'SINGLE',
            id: '280aa21c-86ff-4015-a9d0-531bc761f610',
            dateTypesList: [
                {
                    name: 'Single Select',
                    type: 'SINGLE',
                    id: 'SINGLE',
                },
                {
                    name: 'Multiple Select',
                    type: 'MULTIPLE',
                    id: 'MULTIPLE',
                },
            ],
            properties: {
                required: true,
                readOnly: false,
                width: 'Full',
                updateForbidden: true,
                options: [
                    {
                        name: 'Active',
                        value: 'Active',
                        id: clientStatusesEnum.ACTIVE,
                    },
                    {
                        name: 'Inactive',
                        value: 'Inactive',
                        id: clientStatusesEnum.INACTIVE,
                    },
                    {
                        name: 'FBA',
                        value: 'FBA',
                        id: clientStatusesEnum.FBA,
                    },
                    {
                        name: 'On Hold',
                        value: 'On Hold',
                        id: clientStatusesEnum.ON_HOLD,
                    },
                    {
                        name: 'Waitlist',
                        value: 'Waitlist',
                        id: clientStatusesEnum.WAIT_LIST,
                    },
                    {
                        name: 'Terminated',
                        value: 'Terminated',
                        id: clientStatusesEnum.TERMINATED,
                    },
                    {
                        name: 'Graduated',
                        value: 'Graduated',
                        id: clientStatusesEnum.GRADUATED,
                    },
                ],
            },
        });

        yield put({
            type: GET_CLIENT_FILED_FORM_SUCCESS,
            payload: params,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* changeFormStatus(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(formService.editFormService, action?.payload?.id, { status: action?.payload?.status });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* clientFormReview(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(formService.clientFormReviewService, action?.payload?.clientId, action?.payload?.data, action?.payload?.status);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

export const watchForm = function* watchFormSaga() {
    yield takeLatest(GET_FORMS, getForms);
    // yield takeLatest(GET_BASIC_FORMS, getBasicForms);
    yield takeLatest(GET_FORMS_DEFAULT, getFormDefault);
    yield takeLatest(GET_FORM_BY_ID, getFormById);
    yield takeLatest(GET_FORM_SETTINGS, getFormSettings);
    yield takeLatest(CREATE_FORM, createForm);
    yield takeLatest(EDIT_FORM, editForm);
    yield takeLatest(DELETE_FORM, deleteForms);
    yield takeLatest(CHANGE_FORM_STATUS, changeFormStatus);
    yield takeLatest(GET_CLIENT_INVITE_FORM, getClientInviteForm);
    yield takeLatest(SAVE_INVITE_FORM, saveInviteForm);
    yield takeLatest(RESEND_INVITE_FORM, resendInviteForm);
    yield takeLatest(REQUEST_INVITE_FORM, requestInviteForm);
    yield takeLatest(GET_CLIENT_FILED_FORM, getClientFiledForm);
    yield takeLatest(CLIENT_FORM_REVIEW, clientFormReview);
};
